import React from "react";
import SolidButton from "../../common/buttons/SolidButton";
import { UrlProvider } from "../../../utils/UrlProvider";
import PropTypes from "prop-types";

const Story = ({ item }) => {
  return (
    <div>
      <div className="md:inline-block md:ml-[3vw] ml-[20vw] flex md:w-[30vw] w-fit md:mt-[5vw] mt-[10vw] md:h-[18vw]">
        <img
          src={UrlProvider(item?.story_image?.url)}
          alt={item?.story_image?.alternativeText}
          className="relative object-contain rounded-full md:w-[50%] w-[69%]"
        />
        <img
          src={UrlProvider(item?.customers_speaks?.url)}
          alt={item?.customers_speaks?.alternativeText}
          className="md:w-[50%] w-[71%] relative md:top-[-15vw] top-[-0.9vw] md:left-[-0.2vw] left-[-53vw] z-[10]"
        />
      </div>
      <div className="md:text-left xs:text-center md:w-[60%] w-[80%] xs:mx-auto md:ml-[-10vw] md:inline-block md:align-top md:mt-[4vw] mt-[10vw]">
        <img
          src={UrlProvider(item?.story_watermark?.url)}
          alt={"watermark"}
          className="mx-auto md:mx-0"
        />
        <div className="mt-[2.5vh]">
          <p className="text-[4vw] md:text-[1.3vw] md:leading-[1.8vw] font-krubMedium font-[500]">
            {item?.story_description}
          </p>
        </div>
        <p className="text-[#2E3192] font-krubRegular font-[600] md:text-[1.3vw] xs:text-[4.2vw]  mt-[1.5vh]">
          {item?.story_name}
        </p>
        <p className="md:text-[1.05vw] md:mb-[4.5vh] xs:mb-[3vw] font-krubMedium font-[500]">
          {item?.story_address}
        </p>
        {/* <SolidButton
          label={item?.story_button?.lable}
          href={item?.story_button?.redirection_link}
          label_color={item?.story_button?.lable_color}
          background_color={item?.story_button?.background_color}
        /> */}
      </div>
    </div>
  );
};

Story.propTypes = {
  item: PropTypes.object,
};

export default Story;
